import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { PortalChrome } from "./PortalChrome";

// RECON→FIX (UAT 2026-05-30) — the deal-submission flow (/portal/broker/
// deals/*) used to render in the bare PortalShell, stripping the left
// sidebar + full top nav so the broker couldn't navigate anywhere. Wrap
// those pages in the standard portal chrome instead: the sidebar shows
// "Deals & status" as active, and choosing any entry navigates back to
// that dashboard tab so the broker is never trapped in the wizard.
export function BrokerDealFlowShell({
  pageTitle,
  children,
}: {
  pageTitle: string;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <PortalChrome
      pageTitle={pageTitle}
      activeTab="deals"
      onSelectTab={(id) => navigate(`/portal/broker?tab=${id}`)}
    >
      {children}
    </PortalChrome>
  );
}
